import { render, staticRenderFns } from "./BacLoggedInHeader.vue?vue&type=template&id=47f74b91&scoped=true&"
import script from "./BacLoggedInHeader.vue?vue&type=script&lang=ts&"
export * from "./BacLoggedInHeader.vue?vue&type=script&lang=ts&"
import style0 from "./BacLoggedInHeader.vue?vue&type=style&index=0&id=47f74b91&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f74b91",
  null
  
)

export default component.exports